import React from "react";
import Tabs from "./Tabs";
import { useReactiveVar } from "@apollo/client";
import {
  RentSportEquipmentTab,
  rentSportEquipmentTabActiveVars,
  useRentSportEquipmentTabActiveVars
} from "../../../../store/rent-sport-equpments/rentSportEquipmentTabActive";


export default () => {
  const tabActive = useReactiveVar(rentSportEquipmentTabActiveVars);
  const { setTabActive } = useRentSportEquipmentTabActiveVars();

  if (!tabActive) return null;

  return (
    <>
      <Tabs
        tabActive={tabActive as RentSportEquipmentTab}
        actions={{
          setTabActive
        }}
      />
    </>
  );
};